export default `
  <div class="robo_image"></div>
  <h3 class="old_fw_version_title"></h3>
  <p class="old_fw_version_message"></p>
`;
